// extracted by mini-css-extract-plugin
export default {"cabecera":"CustomTable_cabecera__0AF6W","alignMiddle":"CustomTable_alignMiddle__D0hL6","columna":"CustomTable_columna__xp5fV","titulo":"CustomTable_titulo__IepbW"};